import type { Cursus } from '../lib/types'
import { AI_GEBRUIKEN } from './ai-gebruiken'
import { INKOOPFACTUREN } from './inkoopfacturen'

/* ===========================================================================
 *  De cursussen die er zijn
 *
 *  Eén lijst, met de hand. Geen automatisch inlezen van de map: dan staat er
 *  op een dag een half afgeschreven bestand tussen dat meteen op het scherm
 *  van iedereen verschijnt. Een cursus komt hier pas bij als iemand vindt dat
 *  hij eraan toe is.
 * =========================================================================== */

export const CURSUSSEN: Cursus[] = [
  AI_GEBRUIKEN,
  INKOOPFACTUREN,
]

export function cursusMet(id: string): Cursus | undefined {
  return CURSUSSEN.find((c) => c.id === id)
}

/** Alle les-ids van een cursus, in volgorde. Voor de voortgangsbalk. */
export function alleModuleIds(cursus: Cursus): string[] {
  return cursus.modules.map((m) => m.id)
}
